import React, { createContext, useState, useEffect, useContext } from "react";
import { findPais } from "../repository/ERP/prouser/PaisService";
import { findEstado } from "../repository/ERP/prouser/EstadoService";
import { findMunicipio } from "../repository/ERP/prouser/MunicipioService";
import { findCNDTipo } from "../repository/admQERP/public/CNDTipoService";
import { QueryParamsContext } from "./QueryParamsContext";

const ImutaveisContext = createContext();

const ImutaveisContextProvider = ({ children }) => {
  const [optionsPais, setOptionsPais] = useState([
    { codigo: "1058", descricao: "BRASIL" },
  ]);
  const [optionsCND, setOptionsCND] = useState([]);
  const [optionsEstado, setOptionsEstado] = useState([]);
  const [optionsMunicipio, setOptionsMunicipio] = useState([]);
  const [loadingInputsImutaveis, setLoadingInputsImutaveis] = useState({});
  const { queryParams } = useContext(QueryParamsContext);

  useEffect(() => {
    if (
      (!window.location.href.includes("/cnd/") &&
        !window.location.href.includes("/cliente/")) ||
      window.location.href.includes("prouser")
    ) {
      return;
    }

    const getOptionsPais = async () => {
      try {
        setLoadingInputsImutaveis((prev) => ({ ...prev, optionsPais: true }));

        const { data } = await findPais(queryParams.empresa_cnpj);

        setOptionsPais(data ?? []);
      } catch (error) {
        console.error("ERROR ImutaveisContext getOptionsPais", error);
      } finally {
        setLoadingInputsImutaveis((prev) => ({ ...prev, optionsPais: false }));
      }
    };

    getOptionsPais();
  }, [queryParams.empresa_cnpj]);

  useEffect(() => {
    if (
      (!window.location.href.includes("/cnd/") &&
        !window.location.href.includes("/cliente/")) ||
      window.location.href.includes("prouser")
    ) {
      return;
    }

    const getOptionsEstado = async () => {
      try {
        setLoadingInputsImutaveis((prev) => ({ ...prev, optionsEstado: true }));

        const { data } = await findEstado(queryParams.empresa_cnpj);

        setOptionsEstado(data ?? []);
      } catch (error) {
        console.error("ERROR ImutaveisContext getOptionsEstado", error);
      } finally {
        setLoadingInputsImutaveis((prev) => ({
          ...prev,
          optionsEstado: false,
        }));
      }
    };

    getOptionsEstado();
  }, [queryParams.empresa_cnpj]);

  useEffect(() => {
    if (
      (!window.location.href.includes("/cnd/") &&
        !window.location.href.includes("/cliente/")) ||
      window.location.href.includes("prouser")
    ) {
      return;
    }

    const getOptionsMunicipio = async () => {
      try {
        setLoadingInputsImutaveis((prev) => ({
          ...prev,
          optionsMunicipio: true,
        }));

        const { data } = await findMunicipio(queryParams.empresa_cnpj);

        setOptionsMunicipio(data ?? []);
      } catch (error) {
        console.error("ERROR ImutaveisContext getOptionsMunicipio", error);
      } finally {
        setLoadingInputsImutaveis((prev) => ({
          ...prev,
          optionsMunicipio: false,
        }));
      }
    };

    getOptionsMunicipio();
  }, [queryParams.empresa_cnpj]);

  useEffect(() => {
    if (
      (!window.location.href.includes("/cnd/") &&
        !window.location.href.includes("/cliente/")) ||
      window.location.href.includes("prouser")
    ) {
      return;
    }

    const getOptionsCND = async () => {
      try {
        setLoadingInputsImutaveis((prev) => ({ ...prev, optionsCND: true }));

        const data = await findCNDTipo();

        if (data.success && Array.isArray(data.data)) {
          setOptionsCND(data.data);
        }
      } catch (error) {
        console.error("ERROR ImutaveisContext getOptionsCND", error);
      } finally {
        setLoadingInputsImutaveis((prev) => ({ ...prev, optionsCND: false }));
      }
    };

    getOptionsCND();
  }, []);

  return (
    <ImutaveisContext.Provider
      value={{
        optionsPais,
        setOptionsPais,
        optionsCND,
        setOptionsCND,
        optionsEstado,
        setOptionsEstado,
        optionsMunicipio,
        setOptionsMunicipio,
        loadingInputsImutaveis,
        setLoadingInputsImutaveis,
      }}
    >
      {children}
    </ImutaveisContext.Provider>
  );
};

export { ImutaveisContextProvider, ImutaveisContext };
